/**
 * Tool brand icons — inline SVG with hardcoded brand colors.
 * These never fail to load (no HTTP requests, no hotlink blocking, no CORS).
 */
import React from 'react';

interface IconProps {
  fontSize?: 'inherit' | 'small' | 'medium' | 'large';
  className?: string;
}

const SIZES: Record<string, string | number> = {
  inherit: '1em',
  small: 20,
  medium: 24,
  large: 35,
};

function svgIcon(svgContent: string, viewBox = '0 0 24 24') {
  return function ToolIcon({ fontSize = 'medium', className }: IconProps) {
    const size = SIZES[fontSize] ?? 24;
    return (
      <svg
        viewBox={viewBox}
        width={size}
        height={size}
        className={className}
        style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{ __html: svgContent }}
      />
    );
  };
}

// Grafana — orange flame logo
export const GrafanaIcon = svgIcon(
  '<path fill="#F46800" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 3a7 7 0 1 1 0 14A7 7 0 0 1 12 5zm-.5 2v5.5l4.5 2.7-.75 1.23-5.25-3.18V7h1.5z"/>',
);

// Keycloak — red shield
export const KeycloakIcon = svgIcon(
  '<path fill="#4D9A8A" d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.35C17.25 22.15 21 17.25 21 12V7L12 2zm0 2.18l7 3.89V12c0 4.45-3.09 8.6-7 9.93C8.09 20.6 5 16.45 5 12V8.07l7-3.89z"/><path fill="#4D9A8A" d="M12 7l-5 2.8V12c0 3.13 2.19 5.97 5 6.93 2.81-.96 5-3.8 5-6.93V9.8L12 7z"/>',
);

// ArgoCD — orange circle with branches
export const ArgoCDIcon = svgIcon(
  '<circle cx="12" cy="12" r="10" fill="#EF7B4D"/><path fill="white" d="M8 8h2v8H8zm6 0h2v8h-2zm-3 2h2v4h-2z"/>',
);

// Kibana — yellow K
export const KibanaIcon = svgIcon(
  '<path fill="#F04E98" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-1 5h2v4.5l3.5-4.5H19l-4 5 4 5h-2.5L12 12.5V17h-2V7z"/>',
);

// SonarQube — blue sonar wave
export const SonarQubeIcon = svgIcon(
  '<path fill="#4E9BCD" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>',
);

// MinIO — red elephant
export const MinIOIcon = svgIcon(
  '<path fill="#C72C48" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-2 6h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm0 2v4h4v-4h-4z"/>',
);

// pgAdmin — blue postgres elephant
export const PgAdminIcon = svgIcon(
  '<path fill="#336791" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm1 4v2h1a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-1v2h-2v-2H9v-2h1V9H9V7h2V6h2zm0 2v6h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1z"/>',
);


